import React from "react";
import "./About.css"
import computer from "../../assets/computer.jpg"
import linkedin_img from "../../assets/linkedin.png";
import github_img from "../../assets/icons8-github-48.png";

const About = () => {
    return(
        <div className="about">
            <div className="container">
                <div className="container-picture">
                    <img className="image" src={computer} alt=""/>
                </div>
                <div className="about-section">
                    <div className="about-paragraph">
                        <h1>About me</h1>
                        <p>
                            I am a Software Engineer with a Bachelor of Science in Computer Science. I'm currently pursuing a Master of Science in Computer Science at Georgia Institute of Technology.
                        </p>
                        <p>
                            I'm deeply passionate about software development, always striving to learn and stay on top of the latest technologies. I genuinely enjoy solving complex problems and turning creative ideas into smart, scalable solutions. 
                            My dedication and attention to detail have helped me build a strong and versatile skill set that allows me to deliver high-quality work. I'm driven by my passion for helping others through innovative software solutions.
                        </p>
                    </div>
                </div>
            </div>
            <div className="logos">
                <a href="https://www.linkedin.com/in/antonio-alfaro-6162a2237/" target="_blank" rel="noopener noreferrer">
                    <img src={linkedin_img} alt="LinkedIn" />
                </a>
                <a href="https://github.com/antonioalfaroa" target="_blank" rel="noopener noreferrer">
                    <img src={github_img} alt="GitHub" />
                </a>
            </div>
            <p>© 2026 Antonio Alfaro</p>
        </div>
    )
}

export default About;